export const createList = (list, value) => {
  const array = [];
  list?.map((item) => {
    return array.push({
      title: item[value],
      value: item.id,
    });
  });
  return array;
};
